import type { ExtensionSdk } from './types';

export interface MockSdkOptions {
  config?: unknown;
  fieldValue?: unknown;
  entry?: Record<string, unknown>;
  stackApiKey?: string;
  /** Called whenever the extension writes to its field. */
  onFieldChange?: (value: unknown) => void;
}

/** In-memory ExtensionSdk for tests and the dev harness. */
export function createMockSdk(opts: MockSdkOptions = {}): ExtensionSdk & { fieldValue: () => unknown } {
  let fieldValue = opts.fieldValue;
  const entry = { ...(opts.entry ?? {}) };
  const fieldListeners: Array<(v: unknown) => void> = [];

  return {
    config: opts.config ?? {},
    stackApiKey: opts.stackApiKey ?? 'blt_mock',
    field: {
      get: () => fieldValue,
      set: async (value) => {
        fieldValue = value;
        opts.onFieldChange?.(value);
        fieldListeners.forEach((cb) => cb(value));
      },
      onChange: (cb) => { fieldListeners.push(cb); },
    },
    entry: {
      get: () => entry,
      getFieldValue: (uid) => entry[uid],
      onChange: () => {},
    },
    autoResize: () => {},
    fieldValue: () => fieldValue,
  };
}
